/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, TableContainer, Toolbar } from "@mui/material";
import Table from "@mui/material/Table";
import Paper from "@mui/material/Paper";
import Button from "../../../component/button";

//table imports
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

//icons
// import EditIcon from '@mui/icons-material/Edit';
// import Delete from '@mui/icons-material/Delete';
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {
  DeleteIconNew,
  EditIconNew,
  ViewIconNew,
  PlusIcon,
  AddIcon,
  MyOfferings,
} from "../../../component/icons/icons.js";

import Variations from "./variations";

//tree
import classes from "./component.module.css";

import PropTypes from "prop-types";
import SvgIcon from "@mui/material/SvgIcon";
import { alpha } from "@mui/material/styles";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import Collapse from "@mui/material/Collapse";
import { useSpring, animated } from "@react-spring/web"; // web.cjs is required for IE 11 support
// import Files from 'react-files';
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";

import { Checkbox } from "@mui/material";
import { withTranslation } from "react-i18next";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import Filter1Icon from "@mui/icons-material/Filter1";
import Input from "../../../component/inputpm";
import {
  SearchIcon,
  ClearIcon,
  ClipboardWithGear,
} from "../../../component/icons/icons";
import { Menu } from "@mui/material";
import { styled } from "@mui/material";
import ComponentAssembly from "../packagedSolution/componentAssembly";
import { Box } from "@mui/material";
import { LooksOneOutlined, FilterNoneOutlined } from "@mui/icons-material";
import currencyFormatter from "../../../helper/currencyFormatter";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ComponentBOM from "../packagedSolution/componentBOM";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import Loader from "../../../component/loader";
import actionTypes from "../../../store/actions";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import DehazeIcon from "@mui/icons-material/Dehaze";
import Divider from "@mui/material/Divider";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Chip from "@mui/material/Chip";
import Card from "@mui/material/Card";
// import { withStyles, makeStyles } from '@mui/styles';

import AddSpecCharacteristicsAppl from "./specification/addSpecCharacteristicsAppl.js";
import ImportAllButton from "./importComponent.js";
import { formatNumber } from "../../../helper/numberFormatter";

const ComponentTable = (props) => {
  const [openTreeDialog, setOpenTreeDialog] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedProductName, setSelectedProductName] = useState(null);
  const [selectedProductStatus, setSelectedProductStatus] = useState(null);
  // Open tree dialog
  const handleOpenTreeDialog = (product) => {
    console.log(product);
    setSelectedProductId(product.productId);
    setSelectedProductName(product.name);
    setSelectedProductStatus(product.status);
    setOpenTreeDialog(true);
  };

  // Close tree dialog
  const handleCloseTreeDialog = () => {
    setOpenTreeDialog(false);
    setSelectedProductId(null);
    setSelectedProductName(null);
    setSelectedProductStatus(null);
  };

  //the arrow to display the variations
  const [open, setOpen] = React.useState(false);

  const onFilesError = (error, file) => {
    console.log("error code " + error.code + ": " + error.message);
  };

  //for tree
  // const StyledTreeItem = withStyles((theme) => ({
  //     group: {
  //         marginLeft: 7,
  //         paddingLeft: 18,
  //         borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
  //     },
  // }))((props) => <TreeItem {...props} TransitionComponent={TransitionComponent} />);

  function MinusSquare(props) {
    return (
      <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
      </SvgIcon>
    );
  }

  function PlusSquare(props) {
    return (
      <SvgIcon fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
        {/* tslint:disable-next-line: max-line-length */}
        <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
      </SvgIcon>
    );
  }

  function TransitionComponent(props) {
    const style = useSpring({
      from: { opacity: 0, transform: "translate3d(20px,0,0)" },
      to: {
        opacity: props.in ? 1 : 0,
        transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
      },
    });

    return (
      <animated.div style={style}>
        <Collapse {...props} />
      </animated.div>
    );
  }

  TransitionComponent.propTypes = {
    /**
     * Show the component; triggers the enter or exit states
     */
    in: PropTypes.bool,
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropdownMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (type) => {
    if (type === "component") {
      props.addComponent("component");
    } else if (type === "assembly") {
      props.addComponent("assembly");
    }
    setAnchorEl(null);
  };

  const getPriceTenureUOM = (val) => {
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "YEAR") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "[QUARTER, MONTH]") {
      return "Month";
    } else {
      return "";
    }
  };

  return (
    <div>
      <Paper
        elevation={0}
        style={{ border: "1px solid lightgrey", borderRadius: "8px" }}
      >
        {props.viewMode === "default" && (
          <>
            {props.partnerProducts ? (
              <>
                <Grid
                  item
                  style={{ display: "flex", justifyContent: "space-between" }}
                  size={{
                    xs: 12,
                  }}
                >
                  <h3 style={{ padding: ".5rem 1rem" }}>{props.tableName}</h3>
                </Grid>
              </>
            ) : (
              <>
                <Grid
                  item
                  style={{ display: "flex", justifyContent: "space-between" }}
                  size={{
                    xs: 12,
                  }}
                >
                  <h3 style={{ padding: ".5rem 1rem" }}>{props.tableName}</h3>
                  {props.isBom ? null : (
                    <>
                      {/* {(props.enabledModules.INVENTORY && props.enabledModules.INVENTORY.enabled) ?
                                    <>
                                        {(props.enabledModules.INVENTORY && props.enabledModules.INVENTORY.enabled) ?
                                            <>
                                                <Button
                                                    id="demo-customized-button"
                                                    aria-controls={openDropdownMenu ? 'demo-customized-menu' : undefined}
                                                    aria-haspopup="true"
                                                    aria-expanded={openDropdownMenu ? 'true' : undefined}
                                                    variant="contained"
                                                    disableElevation
                                                    onClick={handleClick}
                                                    endIcon={<KeyboardArrowDownIcon />}
                                                    style={{ float: 'right', marginLeft: '8px' }}
                                                >
                                                    {props.t('NEW') + ' ' + props.tableName}
                                                </Button>
                                                <StyledMenu
                                                    id="demo-customized-menu"
                                                    MenuListProps={{
                                                        'aria-labelledby': 'demo-customized-button',
                                                    }}
                                                    anchorEl={anchorEl}
                                                    open={openDropdownMenu}
                                                    onClose={handleClose}
                                                >
                                                    <MenuItem onClick={() => handleClose('component')} disableRipple>
                                                        {props.t('ADD_COMPONENT')}
                                                    </MenuItem>
                                                    <MenuItem onClick={() => handleClose('assembly')} disableRipple>
                                                        {props.t('ADD_ASSEMBLY')}
                                                    </MenuItem>
                                                </StyledMenu>
                                            </>
                                            :
                                            <>
                                                <Button style={{ float: 'right', marginLeft: '8px' }} onClick={event => handleClose('component')}>{props.t('NEW') + ' ' + props.tableName}</Button>
                                            </>
                                        }
                                    </>
                                } */}
                      {/* <div style={{ float: 'right', marginLeft: '5px', position: 'relative', top: '-2px' }}>
                                            <Tooltip title={props.t('CATEGORY_VIEW')}>
                                                <ViewModuleIcon style={{
                                                    color: props.viewMode === 'default' ? props.tenantData.color : 'grey'
                                                }} fontSize='large' onClick={() => props.changeView('default')} />
                                            </Tooltip>

                                            <Tooltip title={props.t('TABLE_VIEW')}>
                                                <DehazeIcon style={{
                                                    color: props.viewMode === 'search' ? props.tenantData.color : 'grey'
                                                }} fontSize='large' onClick={() => props.changeView('search')} />
                                            </Tooltip>
                                        </div> */}
                      <div
                        style={{
                          display: "flex",
                          gap: ".5rem",
                          alignItems: "center",
                          padding: "0rem 1rem",
                        }}
                      >
                        {/* <Button style={{ float: 'right', marginLeft: '8px' }} onClick={event => props.exportAll()}>{props.t('EXPORT_ALL')}</Button> */}

                        <div>
                          {(props.permissions.includes("CATALOG_ADMIN_ALL") ||
                            props.permissions.includes("CATALOG_CREATE") ||
                            props.permissions.includes("CATALOG_ADMIN")) && (
                            <>
                              {/* <Files
                                                                        className="files-dropzone"
                                                                        onChange={props.importAll}
                                                                        onError={onFilesError}
                                                                        accepts={[".json"]}
                                                                        maxFileSize={10000000}
                                                                        minFileSize={0}
                                                                        clickable={true}
                                                                    >
                                                                        <Button className="buttonSecondary">{props.t('Import')}</Button>
                                                                    </Files> */}
                              <ImportAllButton
                                importAll={props.importAll}
                                onFilesError={onFilesError}
                                t={props.t}
                              />
                            </>
                          )}
                        </div>
                        {props.componentList.length > 0 && (
                          <Button
                            className={"buttonSecondary"}
                            onClick={(event) => props.exportSelectedItems()}
                          >
                            {props.t("EXPORT")}
                          </Button>
                        )}
                        {props.loggedInUserType !== "ECOMMERCE_ADMIN" &&
                          props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                          (props.permissions.includes("CATALOG_ADMIN_ALL") ||
                            props.permissions.includes("CATALOG_CREATE") ||
                            props.permissions.includes("CATALOG_ADMIN")) &&
                          (props.isMobile ? (
                            <Button
                              onClick={(event) => handleClose("component")}
                            >
                              <PlusIcon />
                            </Button>
                          ) : (
                            <Button
                              onClick={(event) => handleClose("component")}
                            >
                              {props.t("NEW") + " " + props.tableName}
                            </Button>
                          ))}
                      </div>
                    </>
                  )}
                </Grid>
              </>
            )}
            {/* {props.componentList.length > 0 && */}

            <div
              className={classes.searchOuterDiv}
              style={{ padding: "0rem .5rem" }}
            >
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={props.t("NAME")}
                  value={props.searchFilter.name}
                  name={"name"}
                  onChange={(e) => {
                    props.updateFilter(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    props.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <Input
                  size={"small"}
                  variant={"outlined"}
                  placeholder={props.t("PRODUCT_CODE")}
                  value={props.searchFilter.featureCode}
                  name={"featureCode"}
                  onChange={(e) => {
                    props.updateFilter(e);
                  }}
                  divClass={classes.inputClass}
                  onKeyDown={(e) => {
                    props.onSearchKeyDown(e);
                  }}
                />
              </div>
              <div>
                <FormControl
                  variant="outlined"
                  className="custom-select-input"
                  size={"small"}
                  style={{ float: "right", width: "180px" }}
                >
                  <InputLabel id="status" htmlFor="outlined-age-native-simple">
                    {" "}
                    {props.t("STATE")}
                  </InputLabel>
                  <Select
                    labelId="productStatus"
                    native
                    size={"small"}
                    label={props.t("STATE")}
                    placeholder={props.t("STATE")}
                    name={"status"}
                    inputProps={{
                      name: "status",
                      id: "outlined-native-status",
                    }}
                    divClass={classes.inputClass}
                    value={props.searchFilter.status}
                    onChange={(e) => {
                      props.updateFilter(e);
                    }}
                    onKeyDown={(e) => {
                      props.onSearchKeyDown(e);
                    }}
                  >
                    <option value="all_products">{props.t("ALL")}</option>
                    <option key="DRAFT" value="P_IN_DRAFT">
                      In Draft
                    </option>
                    <option key="APPROVE" value="P_PUBLISHED">
                      Published
                    </option>
                  </Select>
                </FormControl>
              </div>
              <div>
                {props.partnerProducts && (
                  <FormControl
                    variant="outlined"
                    className="custom-select-input-white-label"
                    style={{ width: "200px", float: "right" }}
                  >
                    <InputLabel htmlFor={"selectedPartner"}>
                      {props.t("PARTNER")}
                    </InputLabel>
                    <Select
                      value={props.searchFilter.selectedPartner}
                      native
                      label={props.t("PARTNER")}
                      onChange={(e) => {
                        props.updateFilter(e);
                      }}
                      inputProps={{
                        name: "selectedPartner",
                        id: "selectedPartner",
                      }}
                    >
                      <option value="-">Select</option>
                      {props.partnerList && props.partnerList.map((partner) => (
                        <option key={partner.id} value={partner.id}>
                          {partner.groupName}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </div>

              {/* <div className={classes.searchOrderLabelOuter}>
                                    <div className={classes.searchOrderLabelInner}> */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <Tooltip title={props.t("SEARCH")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={props.filterComponents}
                  >
                    <SearchIcon />
                  </IconButton>
                </Tooltip>{" "}
                &nbsp;
                <Tooltip title={props.t("CLEAR")}>
                  <IconButton
                    className="iconButtonSecondary"
                    onClick={props.clearFilters}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              </div>
              {/* </div> */}
              {/* <div className='cl'></div> */}
            </div>
            {/* <Tooltip title={props.t('CATEGORY_VIEW')}>
                                <ViewModuleIcon style={{
                                    color: props.viewMode === 'default' ? props.tenantData.color : 'grey'
                                }} fontSize='large' onClick={() => props.changeView('default')} />
                            </Tooltip>

                            <Tooltip title={props.t('TABLE_VIEW')}>
                                <DehazeIcon style={{
                                    color: props.viewMode === 'search' ? props.tenantData.color : 'grey', marginRight: '13px'
                                }} fontSize='large' onClick={() => props.changeView('search')} />
                            </Tooltip> */}
            {/* } */}
            <div style={{ clear: "both" }}></div>
          </>
        )}

        {props.viewMode === "search" && (
          <>
            {props.partnerProducts ? (
              <>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 6,
                  }}
                >
                  <h3 style={{ padding: ".5rem 1rem" }}>
                    {/* {props.tableName} */} {props.t("ALL_PARTNER_PRODUCTS")}
                  </h3>
                </Grid>
              </>
            ) : (
              <Grid
                item
                style={{ display: "flex", justifyContent: "space-between" }}
                size={{
                  xs: 12,
                }}
              >
                <h3 style={{ padding: ".5rem 1rem" }}>
                  {/* {props.tableName} */} {props.t("ALL_PRODUCTS")}
                </h3>
                <div
                  style={{
                    display: "flex",
                    gap: ".5rem",
                    alignItems: "center",
                    padding: "0rem 1rem",
                  }}
                >
                  {(props.permissions.includes("CATALOG_ADMIN_ALL") ||
                    props.permissions.includes("CATALOG_CREATE") ||
                    props.permissions.includes("CATALOG_ADMIN")) && (
                    <div>
                      {/* <Files
                                                    className="files-dropzone"
                                                    onChange={props.importAll}
                                                    onError={onFilesError}
                                                    accepts={[".json"]}
                                                    maxFileSize={10000000}
                                                    minFileSize={0}
                                                    clickable={true}
                                                >
                                                    <Button className='buttonSecondary'>{props.t('Import')}</Button>
                                                </Files> */}
                      <ImportAllButton
                        importAll={props.importAll}
                        onFilesError={onFilesError}
                        t={props.t}
                      />
                    </div>
                  )}
                  <Button
                    className="buttonSecondary"
                    onClick={(event) => props.exportSelectedItems()}
                  >
                    {props.t("EXPORT")}
                  </Button>
                </div>
              </Grid>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: props.partnerProducts ? "auto" : "auto",
                marginLeft: "15px",
                marginRight: "15px",
              }}
            >
              <div className={classes.searchOuterDiv}>
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={props.t("NAME")}
                    value={props.searchFilter.name}
                    name={"name"}
                    onChange={(e) => {
                      props.updateFilter(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      props.onSearchKeyDown(e);
                    }}
                  />
                </div>
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={props.t("PRODUCT_CODE")}
                    value={props.searchFilter.code}
                    name={"code"}
                    onChange={(e) => {
                      props.updateFilter(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      props.onSearchKeyDown(e);
                    }}
                  />
                </div>
                <FormControl
                  variant="outlined"
                  className="custom-select-input"
                  size={"small"}
                  style={{ float: "right", width: "180px" }}
                >
                  <InputLabel id="status" htmlFor="outlined-age-native-simple">
                    {" "}
                    {props.t("STATUS")}
                  </InputLabel>
                  <Select
                    labelId=""
                    native
                    size={"small"}
                    variant={"outlined"}
                    label={props.t("STATUS")}
                    name={"status"}
                    inputProps={{
                      name: "status",
                      id: "outlined-native-status",
                    }}
                    value={props.searchFilter.status}
                    onChange={(e) => {
                      props.updateFilter(e);
                    }}
                    onKeyDown={(e) => {
                      props.onSearchKeyDown(e);
                    }}
                  >
                    <option value="all_products">All Products</option>
                    <option key="DRAFT" value="P_IN_DRAFT">
                      In Draft
                    </option>
                    <option key="APPROVE" value="P_PUBLISHED">
                      Published
                    </option>
                  </Select>
                </FormControl>
                <div>
                  {props.partnerProducts && (
                    <FormControl
                      variant="outlined"
                      className="custom-select-input-white-label"
                      style={{ width: "200px", float: "right" }}
                    >
                      <InputLabel htmlFor={"selectedPartner"}>
                        {props.t("PARTNER")}
                      </InputLabel>
                      <Select
                        value={props.searchFilter.selectedPartner}
                        native
                        label={props.t("PARTNER")}
                        onChange={(e) => {
                          props.updateFilter(e);
                        }}
                        inputProps={{
                          name: "selectedPartner",
                          id: "selectedPartner",
                        }}
                      >
                        <option value="-">Select</option>
                        {props.partnerList && props.partnerList.map((partner) => (
                          <option key={partner.id} value={partner.id}>
                            {partner.groupName}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </div>
                {/* <div className={classes.searchInputDiv}></div> */}
                {/* <div className={classes.searchOrderLabelOuter}>
                                    <div className={classes.searchOrderLabelInner} style={{ paddingRight: '6px' }}> */}
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <Tooltip title={props.t("SEARCH")}>
                    <IconButton
                      className="buttonSecondary"
                      onClick={props.filterComponents}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>{" "}
                  &nbsp;
                  <Tooltip title={props.t("CLEAR")}>
                    <IconButton
                      className="buttonSecondary"
                      onClick={props.clearFilters}
                    >
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                </div>
                {/* </div> */}
                {/* <div className='cl'></div> */}
              </div>
              {/* <Tooltip title={props.t('CATEGORY_VIEW')}>
                                <ViewModuleIcon style={{
                                    color: props.viewMode === 'default' ? props.tenantData.color : 'grey'
                                }} fontSize='large' onClick={() => props.changeView('default')} />
                            </Tooltip>

                            <Tooltip title={props.t('TABLE_VIEW')}>
                                <DehazeIcon style={{
                                    color: props.viewMode === 'search' ? props.tenantData.color : 'grey', marginRight: '13px'
                                }} fontSize='large' onClick={() => props.changeView('search')} />
                            </Tooltip> */}
            </div>
            <div style={{ clear: "both" }}></div>
          </>
        )}
        {props.componentList.length > 0 ? (
          <TableContainer>
            <Table className={"newGlobalTable"}>
              <TableHead>
                <TableRow>
                  {/* the header names will be dynamic too */}
                  <TableCell
                    style={{ width: props.isMobile ? "24px" : "51px" }}
                  >
                    <b>{props.t("EXPAND")}</b>
                  </TableCell>

                  {props.isBom
                    ? null
                    : !props.partnerProducts && (
                        <TableCell style={{ width: "41px" }} align="center">
                          {/* <b>{props.t('SELECT')}</b> */}
                          <Tooltip
                            title={props.t(
                              props.selectAll ? "UNSELECT_ALL" : "SELECT_ALL",
                            )}
                          >
                            <Checkbox
                              color="primary"
                              checked={props.selectAll}
                              onChange={() =>
                                props.selectAllVisibleProducts(!props.selectAll)
                              }
                              name={"selectAll"}
                            />
                          </Tooltip>
                        </TableCell>
                      )}
                  {props.modules &&
                    props.modules.module_manufacturing === "enabled" && (
                      <TableCell style={{ width: "30px" }}>
                        <b>{props.t("TYPE")}</b>
                      </TableCell>
                    )}
                  <TableCell
                    className="global-custom-sorting-header"
                    onClick={(e) => {
                      props.updateSorting("productName");
                    }}
                  >
                    <b>{props.t("NAME")}</b>
                    {props.sortBy === "productName" ? (
                      <span className="material-icons">
                        {props.sortOrder === "DESC"
                          ? "expand_less"
                          : "expand_more"}
                      </span>
                    ) : (
                      <span className="material-icons sorting-indicator-icon">
                        unfold_more
                      </span>
                    )}
                  </TableCell>
                  {props.viewMode === "search" && (
                    <TableCell>{props.t("CATEGORY")}</TableCell>
                  )}
                  <TableCell>
                    {props.partnerProducts
                      ? props.t("PROVIDER")
                      : props.t("CUSTOMER")}
                  </TableCell>
                  <TableCell
                    className="global-custom-sorting-header"
                    onClick={(e) => {
                      props.updateSorting("productCode");
                    }}
                  >
                    <b>{props.t("PRODUCT_CODE")}</b>
                    {props.sortBy === "productCode" ? (
                      <span className="material-icons">
                        {props.sortOrder === "DESC"
                          ? "expand_less"
                          : "expand_more"}
                      </span>
                    ) : (
                      <span className="material-icons sorting-indicator-icon">
                        unfold_more
                      </span>
                    )}
                  </TableCell>
                  <TableCell
                    className="global-custom-sorting-header"
                    onClick={(e) => {
                      props.updateSorting("price");
                    }}
                  >
                    <b>
                      {props.t("PRICE")} ({currencyFormatter("", false)})
                    </b>
                    {props.sortBy === "price" ? (
                      <span className="material-icons">
                        {props.sortOrder === "DESC"
                          ? "expand_less"
                          : "expand_more"}
                      </span>
                    ) : (
                      <span className="material-icons sorting-indicator-icon">
                        unfold_more
                      </span>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <b>{props.t("STATE")}</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>{props.t("ACTION")}</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.componentList.length > 0 ? (
                  props.componentList.map((row, index) => (
                    //only show in the table the value is meant for
                    // row.componentType === props.componentType &&
                    <React.Fragment key={index}>
                      <InlineRow
                        {...props}
                        row={row}
                        index={index}
                        importComponent={props.importComponent}
                        removeComponent={props.removeComponent}
                        updateExportSelection={props.updateExportSelection}
                        components={props.componentList}
                        getPriceTenureUOM={getPriceTenureUOM}
                        getCustomerName={props.getCustomerName}
                        expandProduct={props.expandProduct}
                        handleOpenTreeDialog={handleOpenTreeDialog}
                      />
                    </React.Fragment>
                  ))
                ) : (
                  <TableRow key={1} style={{ cursor: "pointer" }}>
                    {props.viewMode === "search" ? (
                      <TableCell align="center" colSpan={8}>
                        {props.t("NO_PRODUCTS_FOUND")}
                      </TableCell>
                    ) : (
                      <TableCell align="center" colSpan={8}>
                        {props.t("NO_PRODUCTS_DEFINED", { props })}
                      </TableCell>
                    )}
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <>
            <Divider />
            <TableContainer>
              <Table>
                <TableRow key={1} style={{ cursor: "pointer" }}>
                  {props.viewMode === "search" ? (
                    <TableCell align="center" colSpan={8}>
                      {props.t("NO_PRODUCTS_FOUND")}
                    </TableCell>
                  ) : (
                    <TableCell align="center" colSpan={8}>
                      {props.t("NO_PRODUCTS_DEFINED", { props })}
                    </TableCell>
                  )}
                </TableRow>
              </Table>
            </TableContainer>
          </>
        )}
        {props.totalProductsCount > 0 && (
          <div
            className="global-custom-pagination"
            style={{ background: "rgba(196, 196, 196, 0.2)" }}
          >
            <label style={{ float: "left", padding: "5px" }}>
              {props.t("TOTAL_RECORDS")}: {formatNumber(props.totalProductsCount)}
            </label>
            <label>
              {/* Rows per page select */}
              {props.t("ROWS_PER_PAGE")}
              <Select value={props.perPage} onChange={props.changeRowsPerPage}>
                <MenuItem value={10} classes={{ root: "treeRowPerPageItem" }}>
                  10
                </MenuItem>
                <MenuItem value={50} classes={{ root: "treeRowPerPageItem" }}>
                  50
                </MenuItem>
                <MenuItem value={100} classes={{ root: "treeRowPerPageItem" }}>
                  100
                </MenuItem>
              </Select>
            </label>
            {/* Pagination component */}
            <Pagination
              page={props.page}
              count={Math.ceil(props.totalProductsCount / props.perPage)}
              onChange={props.changePage}
              showFirstButton
              showLastButton
            />
          </div>
        )}
      </Paper>
      <AddSpecCharacteristicsAppl
        t={props.t}
        open={openTreeDialog}
        productId={selectedProductId}
        productName={selectedProductName}
        productStatus={selectedProductStatus}
        onClose={handleCloseTreeDialog}
      />
    </div>
  );
};

const InlineRow = (props) => {
  const currentRow = props.row;
  return (
    <>
      <TableRow
        onClick={() => {
          props.isBom && props.importComponent(props.row);
        }}
        style={props.isBom ? { cursor: "pointer" } : {}}
      >
        <TableCell>
          {props.row.hasVariants && (
            <Tooltip title={props.t("EXPAND_VARIANTS")}>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={(event) => {
                  event.stopPropagation();
                  // expandPanel();
                  props.expandProduct(props.row.productId);
                }}
              >
                {props.row.open ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            </Tooltip>
          )}
          {props.row.hasBOM && (
            <Tooltip title={props.t("EXPAND_PRODUCTS")}>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={(event) => {
                  event.stopPropagation();
                  // expandPanel();
                  props.expandProduct(props.row.productId);
                }}
              >
                {props.row.open ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            </Tooltip>
          )}
        </TableCell>
        {props.isBom
          ? null
          : !props.partnerProducts && (
              <TableCell align="center">
                {/* {props.selectedToExport.includes(props.row.productId) ?
                        <Checkbox
                            color="primary"
                            checked={true}
                            onChange={() => props.updateExportSelection(props.row.productId)}
                            name={props.row.productId}
                        />
                        :
                        <Checkbox
                            color="primary"
                            checked={false}
                            onChange={() => props.updateExportSelection(props.row.productId)}
                            name={props.row.productId}
                        />
                    } */}
                {props.selectedToExport.find(
                  (item) => item.id === props.row.productId,
                ) ? (
                  <Tooltip title={props.t("UNSELECT_PRODUCT", { currentRow })}>
                    <Checkbox
                      color="primary"
                      checked={true}
                      onChange={() =>
                        props.updateExportSelection(
                          props.row.productId,
                          props.row.productCode,
                        )
                      }
                      name={props.row.productId}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip title={props.t("SELECT_PRODUCT", { currentRow })}>
                    <Checkbox
                      color="primary"
                      checked={false}
                      onChange={() =>
                        props.updateExportSelection(
                          props.row.productId,
                          props.row.productCode,
                        )
                      }
                      name={props.row.productId}
                    />
                  </Tooltip>
                )}
              </TableCell>
            )}
        {props.modules && props.modules.module_manufacturing === "enabled" && (
          <TableCell align="center">
            <span style={{ display: "flex" }}>
              {props.row.hasBOM ? (
                <Tooltip
                  title={props.t("BOM")}
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <FilterNoneOutlined />
                </Tooltip>
              ) : (
                <Tooltip
                  title={props.t("PRODUCT")}
                  style={{ paddingTop: 0, paddingBottom: 0 }}
                >
                  <LooksOneOutlined />
                </Tooltip>
              )}
            </span>
          </TableCell>
        )}
        <TableCell style={{ whiteSpace: "nowrap" }}>{props.row.name}</TableCell>
        {props.viewMode === "search" && (
          <TableCell style={{ whiteSpace: "nowrap" }}>
            {props.row.productType.name}
          </TableCell>
        )}
        <TableCell style={{ whiteSpace: "pre" }}>
          {props.partnerProducts ? (
            props.row.providerName
          ) : (
            <>
              {props.row.customer && props.row.customer.length > 0 ? (
                <>
                  {props.row.customer.map((item, index) => (
                    <>{props.getCustomerName(item)}</>
                  ))}
                </>
              ) : (
                props.t("ALL")
              )}
            </>
          )}
        </TableCell>
        <TableCell style={{ whiteSpace: "nowrap" }}>
          {props.row.productCode}
        </TableCell>
        <TableCell style={{ whiteSpace: "nowrap" }}>
          {currencyFormatter(props.row.price.priceAmount)}{" "}
          {props.row.price.priceType === "NTC"
            ? props.t("NTC")
            : props.row.price.priceType === "NR"
              ? props.t("NRC")
              : props.t("RC")}
          &nbsp;
          {props.row.price.priceType === "NTC"
            ? props.row.price.priceTenure > 1
              ? "(" +
                "per " +
                props.row.price.priceTenure +
                " " +
                props.getPriceTenureUOM(props.row.price.priceTenureUOM) +
                "s" +
                ")"
              : "(" +
                "per " +
                props.getPriceTenureUOM(props.row.price.priceTenureUOM) +
                ")"
            : ""}
          {props.row.price.priceType === "RC"
            ? props.row.price.termPeriod
              ? props.row.price.termPeriod > 1
                ? "(" +
                  "per " +
                  props.row.price.termPeriod +
                  " " +
                  props.getPriceTenureUOM(props.row.price.termUomId) +
                  "s" +
                  ")"
                : "(" +
                  "per " +
                  props.getPriceTenureUOM(props.row.price.termUomId) +
                  ")"
              : ""
            : ""}
          {/* { props.row.price.priceType === 'RC' ?
                        props.row.price.termType ?
                            props.row.price.termPeriod === '3' ?
                                '(' + props.getPriceTenureUOM('TF_qtr') + ')' :
                                '(' + props.getPriceTenureUOM(props.row.price.termUomId) + ')' :
                            '(' + props.getPriceTenureUOM('TF_mon') + ')' : ''} */}
        </TableCell>
        <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
          {props.row.status && (
            <Chip
              label={props.row.status}
              className={
                props.row.status === "Published"
                  ? "successChip"
                  : "inProgressChip"
              }
            />
          )}
        </TableCell>
        {props.loggedInUserType !== "ECOMMERCE_ADMIN" &&
          props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
          (props.permissions.includes("CATALOG_ADMIN_ALL") ||
            props.permissions.includes("CATALOG_CREATE") ||
            props.permissions.includes("CATALOG_ADMIN") ||
            props.permissions.includes("CATALOG_VIEW")) && (
            <TableCell align="right">
              {props.partnerProducts ? (
                <div
                  style={{
                    display: "flex",
                    gap: ".5rem",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title={props.t("VIEW")}>
                    <IconButton
                      onClick={() => {
                        props.editComponent(props.row, props.index);
                      }}
                      className="buttonSecondary"
                    >
                      <ViewIconNew />
                    </IconButton>
                    {/* <VisibilityIcon onClick={() => { props.editComponent(props.row, props.index) }} /> */}
                  </Tooltip>
                  <Tooltip title={props.t("ASSOCIATED_OFFERINGS")}>
                    <IconButton
                      onClick={() => {
                        props.viewAssociatedOfferings(props.row);
                      }}
                      className="buttonSecondary"
                    >
                      <MyOfferings />
                    </IconButton>
                  </Tooltip>
                  </div>
              ) : (
                <>
                  {props.permissions.includes("CATALOG_ADMIN_ALL") ||
                  props.permissions.includes("CATALOG_CREATE") ||
                  props.permissions.includes("CATALOG_ADMIN") ? (
                    <>
                      {props.isBom ? (
                        <Tooltip title={props.t("ADD")}>
                          <IconButton className="buttonSecondary">
                            <PlusIcon />
                          </IconButton>
                          {/* <AddCircleIcon /> */}
                        </Tooltip>
                      ) : (
                        <>
                          <div
                            style={{
                              display: "flex",
                              gap: ".5rem",
                              justifyContent: "flex-start",
                            }}
                          >
                            <Tooltip
                              title={
                                props.row.status != "Published"
                                  ? props.t("EDIT")
                                  : props.t("VIEW")
                              }
                            >
                              <IconButton
                                onClick={() => {
                                  props.editComponent(props.row, props.index);
                                }}
                                className="buttonSecondary"
                              >
                                {props.row.status != "Published" ? (
                                  <EditIconNew />
                                ) : (
                                  <ViewIconNew />
                                )}
                              </IconButton>
                            </Tooltip>
                            <Tooltip title={props.t("ASSOCIATED_OFFERINGS")}>
                              <IconButton
                                onClick={() => {
                                  props.viewAssociatedOfferings(props.row);
                                }}
                                className="buttonSecondary"
                              >
                                <MyOfferings />
                              </IconButton>
                            </Tooltip>
                            {props.menuPaths.includes("/specification") && (
                              <Tooltip
                                title={`${props.t("ADD")} ${props.t("PRODUCT_SPECIFICATION")}`}
                              >
                                <IconButton
                                  onClick={() => {
                                    props.handleOpenTreeDialog(props.row);
                                  }}
                                  className="buttonSecondary"
                                >
                                  {/*<PlusIcon /> */}
                                  <ClipboardWithGear />
                                </IconButton>
                              </Tooltip>
                            )}
                            {props.row.status != "Published" && (
                              <Tooltip title={props.t("DELETE")}>
                                <IconButton
                                  onClick={() => {
                                    props.removeComponent(
                                      props.row.productId,
                                      props.index,
                                    );
                                  }}
                                  className="buttonSecondary"
                                >
                                  <DeleteIconNew />
                                </IconButton>
                              </Tooltip>
                            )}
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      {props.permissions.includes("CATALOG_VIEW") && (
                        <Tooltip title={props.t("VIEW")}>
                          <IconButton
                            onClick={() => {
                              props.editComponent(props.row, props.index);
                            }}
                            className="buttonSecondary"
                          >
                            <ViewIconNew />
                          </IconButton>
                          {/* <VisibilityIcon onClick={() => { props.editComponent(props.row, props.index) }} /> */}
                        </Tooltip>
                      )}
                    </>
                  )}
                </>
              )}
            </TableCell>
          )}
        {/* <Loader loading={loading} /> */}
      </TableRow>
      {props.row.bom && props.row.bom.length > 0
        ? props.row.open && (
            <ComponentBOM
              index={props.index}
              data={props.row}
              expandVariants={props.row.open}
              mode={"product"}
            />
          )
        : props.row.open && (
            <ComponentVariants
              index={props.index}
              data={props.row}
              expandVariants={props.row.open}
              t={props.t}
              getPriceTenureUOM={props.getPriceTenureUOM}
            />
          )}
    </>
  );
};

const ComponentVariants = (props) => {
  return (
    <TableRow>
      <TableCell></TableCell>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
        <Collapse in={props.expandVariants} timeout="auto" unmountOnExit>
          <Box margin={1}>
            <Card
              variant="outlined"
              style={{
                borderRadius: "8px",
                marginBottom: "1rem",
                marginLeft: "1rem",
                marginRight: "1rem",
              }}
            >
              <TableContainer>
                <Table
                  size="small"
                  aria-label="purchases"
                  className="newGlobalTable roundCorners"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <b>{props.t("NAME")}</b>
                      </TableCell>
                      <TableCell>
                        <b>{props.t("DESCRIPTION")}</b>
                      </TableCell>
                      <TableCell>
                        <b>{props.t("PRODUCT_CODE")}</b>
                      </TableCell>
                      <TableCell>
                        <b>
                          {props.t("PRICE")} ({currencyFormatter("", false)})
                        </b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.data.variants &&
                      props.data.variants.length > 0 &&
                      props.data.variants.map(
                        (opt, variantIndex) =>
                          !opt.deleteId && (
                            <TableRow key={variantIndex}>
                              <TableCell style={{ minWidth: "15%" }}>
                                {opt.name}
                              </TableCell>
                              <TableCell style={{ minWidth: "15%" }}>
                                {opt.description}
                              </TableCell>
                              <TableCell>{opt.featureCode}</TableCell>
                              <TableCell>
                                {currencyFormatter(opt.price)}{" "}
                                {props.data.price.priceType === "NTC"
                                  ? props.t("NTC")
                                  : props.data.price.priceType === "NR"
                                    ? props.t("NRC")
                                    : props.t("RC")}
                                &nbsp;
                                {props.data.price.priceType === "NTC"
                                  ? props.data.price.priceTenure > 1
                                    ? "(" +
                                      "per " +
                                      props.data.price.priceTenure +
                                      " " +
                                      props.getPriceTenureUOM(
                                        props.data.price.priceTenureUOM,
                                      ) +
                                      "s" +
                                      ")"
                                    : "(" +
                                      "per " +
                                      props.getPriceTenureUOM(
                                        props.data.price.priceTenureUOM,
                                      ) +
                                      ")"
                                  : ""}
                                {props.data.price.priceType === "RC"
                                  ? props.data.price.termPeriod
                                    ? props.data.price.termPeriod > 1
                                      ? "(" +
                                        "per " +
                                        props.data.price.termPeriod +
                                        " " +
                                        props.getPriceTenureUOM(
                                          props.data.price.termUomId,
                                        ) +
                                        "s" +
                                        ")"
                                      : "(" +
                                        "per " +
                                        props.getPriceTenureUOM(
                                          props.data.price.termUomId,
                                        ) +
                                        ")"
                                    : ""
                                  : ""}
                              </TableCell>
                            </TableRow>
                          ),
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Box>
        </Collapse>
      </TableCell>
      <TableCell colSpan={2}></TableCell>
    </TableRow>
  );
};

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: 35,
    minWidth: 180,
    color: "rgba(0, 0, 0, 0.8)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
    },
  },
}));

const mapStateToProps = (state) => {
  return {
    enabledModules: state.auth.enabledModules,
    permissions: state.auth.userPerms,
    loggedInUserType: state.auth.userLoginType,
    tenantData: state.auth.tenantData,
    tenantRoles: state.auth.tenantRoles,
    menuPaths: state.auth.menuPaths,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ComponentTable));
